import { cn } from '@/lib/cn';
import { CommandGroup, CommandItem, CommandList } from '@heidi/design-system/command';
import { TypographyCaption } from '@heidi/design-system/typography';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { getPanelNavItemClasses } from '../../../panel-nav-item.styles';
import { useOrganizationSideNavList } from '../../hooks/useOrganizationSideNavList';

export const OrganizationSideBarCommandList = () => {
  const { organizationSideNavList } = useOrganizationSideNavList();

  const router = useRouter();

  return (
    <CommandList
      className={cn(
        'max-h-full flex-1',
        '[&_[cmdk-list-sizer]]:flex [&_[cmdk-list-sizer]]:flex-col [&_[cmdk-list-sizer]]:gap-4'
      )}
    >
      {organizationSideNavList.map((group) => (
        <CommandGroup
          className={cn(
            'space-y-0.5 p-0',
            '[&_[cmdk-group-heading]]:p-1.5 [&_[cmdk-group-heading]]:pt-0',
            '[&_[cmdk-group-items]]:flex [&_[cmdk-group-items]]:flex-col [&_[cmdk-group-items]]:gap-0.5'
          )}
          key={group.label}
          heading={group.label}
        >
          {group.items.map((item) => (
            <div key={item.href} className="space-y-0.5">
              <CommandItem
                data-testid={`settings-item-${item.href.split('/').pop()}`}
                value={item.href}
                className={getPanelNavItemClasses(
                  router.pathname === item.href,
                  'gap-2 p-2'
                )}
                asChild
              >
                <Link href={item.href}>
                  {item.icon({ size: 16 })}
                  <TypographyCaption className="min-w-0 break-words">
                    {item.label}
                  </TypographyCaption>
                </Link>
              </CommandItem>
            </div>
          ))}
        </CommandGroup>
      ))}
    </CommandList>
  );
};
